import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { IApplicationState, TThunkDispatch } from '../../../types/redux';
import { fetchClusters } from '../../../actions/results';
import { useApplicationContext } from '../../ApplicationContext';

export const MapFeaturesFetcher: React.FC = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();
  const mapBounds = useSelector<IApplicationState>(state => state.mapBounds);
  const fetchDelayAlgorithm = React.useRef<'throttle' | 'debounce'>('throttle');
  const fetchDelayTime = React.useRef<number>(1000);

  React.useEffect(() => {
    fetchDelayAlgorithm.current = config.get('mapSearchFrontend.fetchDelayAlgorithm') || 'throttle';
    fetchDelayTime.current = config.get('mapSearchFrontend.fetchDelayTime') || 1000;
  }, [config]);

  React.useEffect(() => {
    dispatch(fetchClusters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapBounds]);

  return null;
};
